import React, { useContext, useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import { PageContainer } from 'layouts';
import { Button, Loader } from 'components';
import { AuthContext, ProductsContext } from 'contexts';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import open from 'utils/open';
import config from '../../../config';
import {
  Template1,
  Template2,
  Template3,
  Template4,
  Template5,
  Template6,
  Template7,
  Template8,
} from './templates';
import RemovableArea from './RemovableArea';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Tooltip from '@material-ui/core/Tooltip';


const templateIdComponentMap = {
  1: Template1,
  2: Template2,
  3: Template3,
  4: Template4,
  5: Template5,
  6: Template6,
  7: Template7,
  8: Template8,
};

const useStyles = makeStyles((theme) => ({
  margin: {
    marginLeft: '16px',
  },
  loader_approve: {
    
  },
  componentVisibility:{
    display:''
  }
}));

const styles = {
  controlsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '18px',
  }
};

let content = {};

const CreateDatasheet = (props) => {
  const classes = useStyles();
  const {bu, category, productName, templateId} = props.match.params;
  const [removed, setRemoved] = useState({});
  const [product, setProduct] = useState(null);
  const {actions} = useContext(ProductsContext);
  const { state: { roles }, actions: authActions } = useContext(AuthContext);
  const templateContainerRef = useRef();

  useEffect(() => {
    if (!roles.length) {
      authActions.fetchRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!product) {
      actions
        .getProductByName(bu, category, productName)
        .then((p) => {
          if (props.match.path.includes('/edit')) {
            setRemoved(p?.template?.removed || {});
            content = p?.template?.content || {};
          }
          setProduct(p);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => (content = {});
  }, []);

  const changeRemoved = (id, value) => {
    setRemoved({
      ...removed,
      [id]: value,
    });
  };

  const changeContent = (id, value) => {
    const newContent = {...content};
    _.set(newContent, id, value);
    if (!value)
      delete newContent[id];
    content = newContent;
  };

  const Template = templateIdComponentMap[templateId] || (
    <div>No template #{templateId} found</div>
  );

  const ConnectedRemovableArea = (props) => (
    <RemovableArea
      {...props}
      removed={String(removed[props.id])}
      onClick={() => {
        setRemoved({
          ...removed,
          [props.id]: !removed[props.id],
        });
      }}
    />
  );

  const removeEmptyPages = (el) =>
    el.querySelectorAll('#content').forEach((e) => {
      const emptyPattern = 'e="true"><p><br data-cke-filler="true"></p></div>';
      const isEmptyPage = [...e.children].some(
        (el) =>
          el.getAttribute('id') === 'canBeEmptyPage' &&
          el.innerHTML.search(emptyPattern) > 0
      );
      if (![...e.children].length || isEmptyPage) {
        const tmplContainer = e.parentNode?.parentNode?.parentNode;
        const currentPage = e.parentNode?.parentNode;
        tmplContainer.removeChild(currentPage);
      }
    });

  const removeMarkedAreas = (el) =>
    el
      .querySelectorAll('[data-removable]')
      .forEach((e) => removed[e.id] && e.parentNode.removeChild(e));

  const removeSvg = (el)=>el.querySelectorAll('figure svg').forEach((e)=>{
      e.parentNode.removeChild(e);
  });

  /*
  const removeTableHeaders = (el) => el.querySelectorAll('figure.table').forEach((e)=>{
    const table = e.querySelectorAll('table');
    e.parentNode.removeChild(e);
    console.log(table);
   
  });*/
  const style_block = document.createElement('style');
  style_block.innerHTML = `
      figure {
        margin:0;
        padding:0;
      }
      table {
        border-collapse: collapse;
        width: 100%;
      }
      img{
        max-width: 100% !important;
        margin:0;
      }
      span.image-inline {
          display: inline-flex;
          align-items: flex-start;
          position: relative;
      }
    `;
  const getTemplateHTML = () => {
    const el = templateContainerRef.current.cloneNode(true);
    removeMarkedAreas(el);
    removeEmptyPages(el);
    removeSvg(el);
    el.appendChild(style_block)
    console.log(el)
    return el.innerHTML;
  };

  const preview = () =>
    open(
      'POST',
      `${config.API_URL}products/pdf`,
      {datasheet: getTemplateHTML()},
      '_blank'
    );

  const save = async () => {
    await actions.saveProductDatasheet(productName, templateId, {
      html: getTemplateHTML(),
      content,
      removed
    });
    props.history.goBack();
  };

  const approve = async () => {
    setLoading(true);
    await actions.approveProductDatasheet(productName, templateId, {
      html: getTemplateHTML(),
      content,
      removed
    });
    setLoading(false);
    props.history.goBack();
  };

  const canApprove = roles.includes('admin') || roles.includes(`${bu}_approve_datasheet`);

  const [loading, setLoading] = useState(false);


  return (
    <>
      <PageContainer component="main" maxWidth={false}>

      {loading ? (
        <Loader size={35} className={classes.loader_approve}/>
        ):(
          <div style={styles.controlsContainer}>
          <Tooltip title="Back" arrow>
            <IconButton onClick={() => props.history.goBack()}>
              <ArrowBackIcon/>
            </IconButton>
          </Tooltip>
          <div>
            <Button variant="outlined" color="primary" onClick={preview}>
              Preview
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.margin}
              onClick={save}
            >
              Save
            </Button>
            {canApprove && (
              <Button
                variant="contained"
                color="primary"
                className={classes.margin}
                onClick={approve}
              >
                Approve
              </Button>
            )}
          </div>
        </div>
       )}


          {product && roles.length ? (
            <Template
              containerRef={templateContainerRef}
              removed={removed}
              changeRemoved={changeRemoved}
              changeContent={changeContent}
              removableArea={ConnectedRemovableArea}
              product={product}
              content={content}
            />
          ) : (
            <Loader size={30}/>
          )}
      </PageContainer>
    </>
  );
};

export default withRouter(CreateDatasheet);
